export default "__VITE_ASSET__S865j3co__"